import React, { useEffect, useState } from 'react';
import './metrology.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useIntl } from 'react-intl';
import Loader from '../../../components/base/Loader/Loader';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import { loadMetrologyData } from '../actions';
import { getSystemData } from '../../System/reducer';
import { responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';
import { getMetrologyData } from '../reducer';
import MetrologyForm from './MetrologyForm';
import { dateTimeFormatter, getCertStatus } from '../../../utils/formatters';
import VerticalGrid from '../../../components/base/Grid/VerticalGrid';

export default function MetrologyPage() {
  const showMetrologyMasterButton = false;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const { status, updatePeriod } = useSelector(getSystemData);
  const {
    loadingSaveMetrology,
    loadingMetrologyData,
    metrologyData = {},
  } = useSelector(getMetrologyData);
  const [showForm, setShowForm] = useState(false);
  const loadData = () => {
    const p1 = dispatch(loadMetrologyData()).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  const rows = {
    diff: formatMessage({ id: 'metrology.diff' }),
    verification_date: formatMessage({ id: 'metrology.date_start' }),
    verification_end_date: formatMessage({ id: 'metrology.date_end' }),
    certificate_number: formatMessage({ id: 'metrology.certificate_number' }),
  };
  const globalTime = status.global_time ? moment(status.global_time) : new Date();
  const vDiff = metrologyData.verification_end_date && globalTime ? moment(metrologyData.verification_end_date).diff(globalTime, 'd') : null;
  const data = {
    diff: getCertStatus(vDiff),
    verification_date: dateTimeFormatter(metrologyData.verification_date),
    verification_end_date: dateTimeFormatter(metrologyData.verification_end_date),
    certificate_number: metrologyData.certificate_number,
  };

  const renderInfo = () => (
    <div className="metrology-info-block">
      <div className="metrology-image-wrapper">
        <div className="f4">{formatMessage({ id: 'metrology.certificate' })}</div>
        <div className="metrology-image-block mt-3">
          {metrologyData.certificate_image ? <img className="metrology-image" src={metrologyData.certificate_image} alt={formatMessage({ id: 'metrology.certificate' })} /> : formatMessage({ id: 'empty.data' })}
        </div>
      </div>
      <div className="metrology-form metrology-view">
        <div className="f4">{formatMessage({ id: 'metrology.verification.data' })}</div>
        <VerticalGrid data={data} rows={rows} />
        <Button className="mt-3 save-button" onClick={() => setShowForm(true)}>{formatMessage({ id: 'app.edit' })}</Button>
      </div>
    </div>
  );

  return (
    <div className="page metrology-page">
      <Loader loading={loadingMetrologyData || loadingSaveMetrology} global />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.metrology' })}</div>
        {showMetrologyMasterButton && (
          <FilterRow>
            <Button
              variant="secondary"
              onClick={() => {
                navigate('/metrology-master');
              }}
            >
              <Icons customIcon className="btn-icon" width={18} height={18} icon="star" /> {formatMessage({ id: 'metrology.master' })}
            </Button>
          </FilterRow>
        )}
      </div>
      <div className="page-content-wrapper frame">
        <div className="page-content p-3">
          {showForm ? <MetrologyForm loadData={loadData} cancel={() => setShowForm(false)} /> : renderInfo()}
        </div>
      </div>
    </div>
  );
}
